import React from 'react';
import '../Styles/styles.css';

const DigitalOfficeFramework = () => {
    return (
        <section id="about" className="about py-5">
            <div className="container">
                <div className="section-title">
                    <h2>Digital Office Framework</h2>
                </div>
                <div className="text-center">
                    <p className="text-muted">Upgrading Office to Digital</p>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Client</h4>
                        <p className="card-text">The client is a subsidiary of the Reserve Bank of India and has offices that are geographically separate.</p>
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Business Challenge</h4>
                        <p className="card-text">Some of the problems associated with document management before EDICT Workflow:</p>
                        <ul>
                            <li>Difficulty in locating documents.</li>
                            <li>Delays due to absent responsible personnel.</li>
                            <li>Risk of loss or misplacement.</li>
                            <li>Manual transfers causing processing delays.</li>
                            <li>Limited accessibility once stored.</li>
                        </ul>
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Solution</h4>
                        <p className="card-text">The client implemented a Microsoft-based solution with Windows Server, Exchange, and Outlook, integrating EDICT Workflow for electronic document movement, instant retrieval, and real-time tracking.</p>
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Gains</h4>
                        <ul>
                            <li>Simultaneous access for authorized users.</li>
                            <li>Faster document processing.</li>
                            <li>Elimination of wait times.</li>
                            <li>Real-time document tracking.</li>
                            <li>Improved security and productivity.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DigitalOfficeFramework;